export const COMPLAINT = 'COMPLAINT';
export const ONLINE_BOOKING = 'ONLINE_BOOKING';
export const MOVIES_INQUIRY = 'MOVIES_INQUIRY';
export const GENERAL_INQUIRY = 'GENERAL_INQUIRY';
export const I_CAN_NOT_BOOK_A_TICKET = 'I_CAN_NOT_BOOK_A_TICKET';

export const categoryList = [ONLINE_BOOKING, COMPLAINT, MOVIES_INQUIRY, GENERAL_INQUIRY];
export const complaintSubCategoryList = [
  'I_AM_NOT_HAPPY_WITH_THE_CLEANLINESS_OF_THE_CINEMA',
  'I_HAVE_WAITED_TOO_LONG_IN_THE_QUEUE',
  'I_AM_NOT_SATISFIED_WITH_THE_FOOD_AND_BEVERAGES_SERVED',
  'I_AM_UNHAPPY_ABOUT_THE_SERVICE_OF_STAFF',
  'I_AM_UNHAPPY_WITH_THE_TEMPERATURE_OF_THE_CINEMA',
  'I_AM_UNHAPPY_WITH_THE_QUALITY_OF_THE_MOVIE_SHOWN',
  'OTHERS',
];
export const onlineSubCategoryList = [
  'I_DID_NOT_RECEIVE_MY_TICKET',
  'I_BOOKED_THE_WRONG_TICKET',
  'MY_PAYMENT_IS_UNSUCCESSFUL',
  'I_RECEIVED_ERROR_MESSAGE',
  'I_CAN_NOT_BOOK_A_TICKET',
];
